/** Flatten an API error body to an error object for Redux form
 * API: { status: 'error',
 * errors: [{ location: body, name: 'nested.field', description: 'fail' }] }
 * mapErrors(API, {'nested.field': 'field'}) ->
 * { field: 'fail' }
 */
export { isStringAuthorizeHtml, authorizeHtml, unprotectAuthorizedHtml } from './protectStrings';
export function mapErrors(response, fields) {
  if (!response) return {};
  const errors = {};
  if (typeof response.message === 'string') {
    // $FlowFixMe[prop-missing]
    errors._error = response.message;
  }
  if (Array.isArray(response.errors)) {
    response.errors.forEach(error => {
      let key = error.name;
      if (fields) {
        key = fields[error.name] ? fields[error.name] : '_error';
      }

      // $FlowFixMe[prop-missing]
      // $FlowFixMe[invalid-computed-prop]
      errors[key] = (errors[key] ? `${errors[key]}\n` : '') + error.description;
    });
  }
  return errors;
}

/**
 * Class usefull to trigger an exception when the validation has failed.
 *
 * Usage example:
 *
 * this.validate()
 *   .then(() => {
 *     // retrieve errors set in the selected step, and set them to the form
 *     const errors: FormErrors = get(fullProps.selectedStep, 'errors', {});
 *     throw new FormValidationError('Error when validation the contact', errors);
 *   })
 *   .catch((err) => {
 *     if (err.name === 'FormValidationError') {
 *       throw new SubmissionError(err.errors);
 *     }
 *
 *     logger.error({ err }, 'Error during contacts validation.');
 *     dispatch(notifyDanger(
 *       __('An error occurred. Please try to reload the page.')
 *     ));
 *   });
 */
export class FormValidationError extends Error {
  constructor(message, errors = {}) {
    super(message);
    this.name = 'FormValidationError';
    this.errors = errors;
  }
}

/**
 * Return a nested structure from a path with dots.
 * Example:
 *
 * nest('extra.foo.bar', 'baz') =>
 *
 * {
 *   extra: {
 *     foo: {
 *       bar: 'baz',
 *     },
 *   },
 * }
 */
// $FlowFixMe[unclear-type]
export function nest(path, value) {
  const shouldNest = /\./.test(path);
  if (shouldNest) {
    const splittedPath = path.split('.');
    const firstKey = splittedPath.shift();
    return {
      // $FlowFixMe[invalid-computed-prop]
      [firstKey]: nest(splittedPath.join('.'), value)
    };
  }
  return {
    [path]: value
  };
}